import axios from "axios";

import ConnUrls from '../Connections/ConnectURL'


const orderMyFood = async (obj) => {
    let dFromF = await axios.post(ConnUrls.ApiUrl + "order/nOrder", obj);
    return (dFromF.data);
}

const getOrder = async (id, obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "order/" + id, obj);
    return (dFromF.data);
}


const updateOrder = async (id, obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "order/upOrd/" + id, obj);
    return (dFromF.data);
}



const getOrderBySearch = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "order/bySearch",  { params: obj });
    return (dFromF.data);
}


const getAllOrders = async (obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "order/all", obj);
    return (dFromF.data);
}

const getOrdersBy = async (obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "order/ordsBy", obj);
    return (dFromF.data);
}


const updateStatus = async (obj) => {
    
    let dFromF = await axios.put(ConnUrls.ApiUrl + "order/upstat", obj);
    return (dFromF.data);
}


const refreshList = async (obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "order/refOrds", obj);
    console.log(dFromF.data)
    return (dFromF.data);
}


const getOrdersHistoryList = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "order/getOrdersHistoryList", { params: obj });
    return (dFromF.data);
}




export default {
    // getClosedOrders,
    getAllOrders,
    orderMyFood,
    getOrder,
    // getOpenOrders,
    getOrderBySearch,
    updateStatus,
    getOrdersBy,
    refreshList,
    updateOrder,
    getOrdersHistoryList
};